
    <div class="content">
        Admin Index

<!-- 
        <HR><BR> 
        <app-mappings [serviceId]="'bb8eac89-8b0d-4c85-b976-4a8e2c7903a5'"></app-mappings>
      -->
    <div><a routerLink="/admin/bible-book">Bible Books</a></div>
    <div><a routerLink="/admin/calendar-item">Calendar Items</a></div>
    <div><a routerLink="/admin/feast-type">Feast Types</a></div>
    <div><a routerLink="/admin/languages">Languages</a></div>
    <div><a routerLink="/admin/language-style">Language Styles</a></div>

    <div><a routerLink="/admin/lectionary-item">Lectionary Items</a></div>
    <div><a routerLink="/admin/lectionary-item-name">Lectionary Item Names</a></div>
    <div><a routerLink="/admin/lectionary-item-name-validate">Lectionary Item Name Validator</a></div>
    <div><a routerLink="/admin/lectionary-item-type">Lectionary Item Types</a></div>
    <div><a routerLink="/admin/lectionary-source">Lectionary Sources</a></div>
    <div><a routerLink="/admin/lectionary-track">Lectionary Tracks</a></div>
    <div><a routerLink="/admin/lectionary-year">Lectionary Years</a></div>

    <div><a routerLink="/admin/liturgy-type">Liturgy Types</a></div>
    <div><a routerLink="/admin/liturgy-type-lectionary-item-type-display-order">Liturgy Type\Lectionary Item Type Display Order</a></div>
    <div><a routerLink="/admin/psalter">Psalter</a></div>
    <div><a routerLink="/admin/pronunciation">Pronunciation</a></div>
    <div><a routerLink="/admin/proper">Propers</a></div>
    <div><a routerLink="/admin/season">Seasons</a></div>

    <div><a routerLink="/admin/service">Services</a></div> 
    <div><a routerLink="/admin/service-date-type">Service Date Types</a></div>

    <div><a routerLink="/admin/religion-branch">Religion Branch</a></div>
    <div><a routerLink="/admin/religion-branch-type">Religion Branch Type</a></div>

    <div><a routerLink="/admin/vestment-color">Vestment Color</a></div>
    <div><a routerLink="/admin/user-management">User Management</a></div>

    <BR>
        <div><a routerLink="/admin/css">Edit Style Sheet</a></div>
        <div><a routerLink="/admin/clear-cache">Clear Cache</a></div>
        <div><a routerLink="/admin/db-status-report">Database Status Reports</a></div>


    <div class="htmlContainer">
        
        <!-- <app-lectionary-item-html-editor [textAreaValue]="htmlEditorText" (valueChanged)="valueChanged($event)"></app-lectionary-item-html-editor> -->
    </div> 